import { Injectable } from '@angular/core';
import { ContactUsModel } from '../pages/contact-us/contact-us.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environment/environment';
import firebase from 'firebase';

@Injectable()
export class ContactUsProvider {
  backendURL = environment.backendURL;

  constructor(public http: HttpClient) {}


  async sendForm(formValues: ContactUsModel) {

    let data = formValues;
    let token;

    await firebase.auth().currentUser.getIdToken(true).then(idToken => {
      token = idToken;
    }).catch(error => {
      return Promise.reject(error);
    });

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };

    return new Promise((resolve, reject) => {

      this.http.post((this.backendURL + 'sendDataToSheet'), data, httpOptions)
        .subscribe((res) => {

          if (res['result'] == 'success')
            return resolve(res);

          return reject();
        })
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/contact-us.service.ts